import { MapPin } from 'lucide-react';

import clinicianImage from '@/assets/appointment/clinician.png';
import type { AppointmentProvider } from '@/types/order.type.ts';

type Props = {
  clinician: AppointmentProvider;
};

export default function ClinicianInfoCard({ clinician }: Props) {
  const name = clinician.name ?? 'ConduitHealth Clinician';

  return (
    <div className="flex gap-x-3 gap-y-1 rounded-md border border-marigold-500 bg-[#fff9f0] p-3">
      <div className="size-16 shrink-0 overflow-hidden rounded-full border border-marigold-500 bg-white">
        <img src={clinicianImage} alt={name} className="size-full object-cover" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-2">
        <p className="text-base leading-4 font-medium">{name}</p>
        <div className="flex flex-col justify-center gap-2">
          <div className="flex items-center gap-2">
            <MapPin className="size-[14px] shrink-0 text-foreground" aria-hidden="true" />
            <span className="text-sm leading-5">Licensed Physician</span>
          </div>
        </div>
      </div>
    </div>
  );
}
